import React, { memo, useMemo } from 'react';
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';

import palette from '../styles/palette';
import StaticBanner from '.';
import { CANCEL, CONTINUE } from '../../constants/strings';

const useStyles = makeStyles(() => ({
  button: {
    minWidth: '3.125rem',
    color: palette.modalButtons.blue,
    fontWeight: 500,
    marginLeft: '10px',
  },
  bgRed: {
    color: palette.dpdRed,
  },
}));

const StaticBannerWithConfirmActions = ({
  onContinue,
  onCancel,
  message,
  ...props
}) => {
  const classes = useStyles();
  const actionMessage = useMemo(
    () => (
      <>
        {message}
        <Button
          color="secondary"
          size="small"
          className={classes.button}
          onClick={onContinue}
        >
          {CONTINUE}
        </Button>
        <Button
          color="secondary"
          size="small"
          className={classes.bgRed}
          onClick={onCancel}
        >
          {CANCEL}
        </Button>
      </>
    ),
    [message, onCancel, onContinue]
  );
  return <StaticBanner message={actionMessage} {...props} />;
};

export default memo(StaticBannerWithConfirmActions);
